import React from 'react';

import fetch from './fetch';


const getStatus = () => {
    return fetch.get('license/getStatus', {})
}


export default {
    getStatus,
}